import { z } from "zod";

export enum Algorithm {
  "TOP_PRODUCTS" = "TOP_PRODUCTS",
  "PERSONAL" = "PERSONAL",
  "CART" = "CART",
  "STYLE_WITH" = "STYLE_WITH",
  "ALTERNATIVES" = "ALTERNATIVES",
  "UPSELL" = "UPSELL",
  "NEWEST_PRODUCTS" = "NEWEST_PRODUCTS",
  "FAVORITES" = "FAVORITES",
  "MORE_FROM_SERIES" = "MORE_FROM_SERIES",
  "RECENTLY_VIEWED" = "RECENTLY_VIEWED",
  "ADD_TO_CART_RECS" = "ADD_TO_CART_RECS",
}

export const productRule = z.object({
  id: z.string(),
  productRules: z.string(),
  limit: z.number().optional(),
  algorithm: z.nativeEnum(Algorithm).optional(),
  params: z
    .object({
      productKey: z.string().optional(),
      cart: z.array(z.string()).optional(),
    })
    .optional(),
});

export type ProductRule = z.infer<typeof productRule>;

export type ProductRuleConfig = {
  attribute: string;
  values?: string[];
  operation?: "excl" | "incl";
  algorithm?: ProductRule["algorithm"];
  params?: ProductRule["params"];
  id?: string;
};

export function createProductRules(
  ...args: ProductRuleConfig[]
): ProductRule[] {
  return args.map(
    (
      {
        attribute,
        values = ["noop"],
        operation = "incl",
        algorithm,
        params,
        id,
      },
      index,
    ) => {
      const productRules = `rule ${operation} ${attribute} { ${values.map((value) => `"${value}"`).join(" ")} }`;
      return {
        id: id ?? "dynamic_" + index,
        productRules,
        limit: values.length,
        algorithm,
        params,
      };
    },
  );
}
